// The CookieYes consent cookie, read by cookie-consent.ts and (read/written by)
// cookie-consent-debug.ts - one parser, so the two can't drift apart.
//
// Format: "consentid:<id>,consent:yes|no,action:yes,<category>:yes|no,..." - also what
// ModulePermissions reads server-side (Features/UmbracoEngage).

export const COOKIE_NAME = "cookieyes-consent";

export function readConsentCookie(): Map<string, string> {
    const values = new Map<string, string>();
    const raw = document.cookie
        .split(";")
        .map((part) => part.trim())
        .find((part) => part.startsWith(`${COOKIE_NAME}=`));
    for (const pair of raw?.slice(COOKIE_NAME.length + 1).split(",") ?? []) {
        const [key, value] = pair.split(":");
        if (key) {
            values.set(key, value ?? "");
        }
    }
    return values;
}
